export default __webpack_public_path__ + "static/assets/adc0b35e696de431abb9dd3ea90a5deb.svg";